import React from 'react'
import { Link } from 'react-router-dom';

export const Button = ({text, className, action}) => {
    return (
        <div>
            <Link to={action} className={className}>{text}</Link>
        </div>
    )
}
